import React from "react";
import { Stack, TextField } from "@mui/material";
import { LuSearch } from "react-icons/lu";

function GlobalSearch() {
  return (
    <TextField
      variant="outlined"
      fullWidth
      autoComplete="off"
      placeholder="Bạn muốn tìm gì ?"
      sx={{
        "& .MuiInputBase-root": {
          border: "1px solid",
          borderColor: "divider",
          "&:focus-within": {
            outline: "1px solid",
            outlineColor: "primary.main",
            borderColor: "primary.main",
          },
          "& .MuiInputBase-input": {
            px: 2,
            py: 1,
            height: "34px",
          },
          "& fieldset": {
            border: "none",
          },
        },
      }}
      slotProps={{
        input: {
          endAdornment: (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{ color: "text.primary" }}
            >
              <LuSearch size={20} />
            </Stack>
          ),
        },
      }}
    />
  );
}

export default GlobalSearch;
